import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const Disclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-8 text-gray-400 hover:text-white"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Torna alla Home
        </Button>

        <h1 className="text-4xl font-bold mb-8">Disclaimer</h1>
        <p className="text-gray-400 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Informazioni Generali</h2>
            <p>
              Le informazioni contenute in questo sito web sono fornite da Digital Performances a scopo puramente
              informativo. Pur facendo ogni sforzo per garantire l'accuratezza delle informazioni, non possiamo
              garantire che tutte le informazioni siano sempre accurate, complete o aggiornate.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Nessuna Garanzia</h2>
            <p className="mb-4">
              Il sito e i contenuti sono forniti "così come sono" e "come disponibili", senza garanzie di alcun tipo,
              esplicite o implicite, incluse ma non limitate a:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Garanzie di commerciabilità</li>
              <li>Idoneità per uno scopo particolare</li>
              <li>Non violazione di diritti di terzi</li>
              <li>Accuratezza, completezza o affidabilità delle informazioni</li>
              <li>Assenza di errori, virus o altri componenti dannosi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Limitazione di Responsabilità</h2>
            <p className="mb-4">
              Nella misura massima consentita dalla legge applicabile, Digital Performances, i suoi amministratori,
              dipendenti, partner e fornitori non saranno responsabili per:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Perdite o danni diretti, indiretti, incidentali, consequenziali o punitivi</li>
              <li>Perdita di profitti, ricavi, dati o opportunità commerciali</li>
              <li>Interruzioni dell'attività o perdita di informazioni</li>
              <li>Danni derivanti dall'uso o dall'impossibilità di utilizzare il sito</li>
              <li>Errori, omissioni o inesattezze nelle informazioni fornite</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Accuratezza delle Informazioni</h2>
            <p>
              Sebbene ci impegniamo a mantenere le informazioni sul sito aggiornate e accurate, possono verificarsi
              errori occasionali. Non garantiamo l'accuratezza, la completezza o l'attualità di qualsiasi informazione
              sul sito.
            </p>
            <p className="mt-4">
              Le informazioni sui servizi, i prezzi e le disponibilità sono soggette a modifiche senza preavviso.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Link Esterni</h2>
            <p>
              Il nostro sito può contenere link a siti web di terze parti. Questi link sono forniti solo per tua
              comodità e non implicano alcuna approvazione o raccomandazione da parte nostra.
            </p>
            <p className="mt-4">
              Non abbiamo alcun controllo sui contenuti di siti web esterni e non siamo responsabili per il loro
              contenuto, le loro politiche sulla privacy o le loro pratiche. L'accesso a tali siti è a tuo rischio e
              pericolo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Contenuti Generati da Terze Parti</h2>
            <p>
              Il sito può includere contenuti forniti da terze parti, come testimonianze, recensioni o commenti.
              Tali contenuti riflettono le opinioni dei rispettivi autori e non necessariamente quelle di Digital
              Performances.
            </p>
            <p className="mt-4">
              Non verifichiamo né approviamo i contenuti generati da terze parti e non siamo responsabili per la loro
              accuratezza o affidabilità.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Servizi Professionali</h2>
            <p>
              Le informazioni contenute in questo sito non costituiscono consulenza professionale. Non dovrebbero essere
              considerate come sostituto di consulenza professionale specifica relativa alla tua situazione particolare.
            </p>
            <p className="mt-4">
              Prima di prendere decisioni basate sulle informazioni fornite, ti consigliamo di consultare professionisti
              qualificati per valutare la tua situazione specifica.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Modifiche e Aggiornamenti</h2>
            <p>
              Ci riserviamo il diritto di modificare, sospendere o interrompere qualsiasi aspetto del sito in qualsiasi
              momento senza preavviso, inclusi la disponibilità di funzionalità, database o contenuti.
            </p>
            <p className="mt-4">
              Possiamo anche imporre limiti su determinate funzionalità o limitare l'accesso a parti o all'intero sito
              senza preavviso o responsabilità.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Disponibilità del Sito</h2>
            <p>
              Non garantiamo che il sito sarà sempre disponibile, accessibile o privo di errori. Il sito potrebbe essere
              soggetto a limitazioni, ritardi e altri problemi inerenti all'uso di Internet e delle comunicazioni
              elettroniche.
            </p>
            <p className="mt-4">
              Non siamo responsabili per eventuali ritardi, interruzioni o errori nel funzionamento del sito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Virus e Sicurezza</h2>
            <p>
              Sebbene adottiamo misure ragionevoli per proteggere il sito da virus e altri codici dannosi, non possiamo
              garantire che il sito o i suoi contenuti siano privi di virus, worm, trojan o altri componenti dannosi.
            </p>
            <p className="mt-4">
              Sei responsabile dell'implementazione di procedure e controlli di sicurezza adeguati per soddisfare i tuoi
              requisiti specifici di protezione antivirus e accuratezza dei dati.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Proprietà Intellettuale</h2>
            <p>
              Tutti i marchi, loghi e marchi di servizio visualizzati sul sito sono di proprietà di Digital Performances
              o dei rispettivi proprietari. Nulla contenuto in questo sito deve essere interpretato come concessione di
              alcuna licenza o diritto di utilizzare qualsiasi marchio senza il permesso scritto preventivo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Legge Applicabile</h2>
            <p>
              Questo disclaimer è regolato e interpretato in conformità con le leggi italiane. Qualsiasi controversia
              derivante da o relativa a questo disclaimer sarà soggetta alla giurisdizione esclusiva dei tribunali
              italiani.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">13. Divisibilità</h2>
            <p>
              Se una qualsiasi disposizione di questo disclaimer viene ritenuta invalida o inapplicabile da un tribunale
              competente, tale disposizione sarà modificata nella misura minima necessaria per renderla valida e
              applicabile, o se ciò non è possibile, sarà eliminata, e le restanti disposizioni continueranno ad avere
              piena efficacia.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">14. Accettazione del Disclaimer</h2>
            <p>
              Utilizzando questo sito, riconosci di aver letto, compreso e accettato i termini di questo disclaimer.
              Se non accetti questo disclaimer, ti preghiamo di non utilizzare il sito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">15. Contatti</h2>
            <p>
              Per domande o chiarimenti su questo disclaimer, contattaci a:
            </p>
            <p className="mt-4">
              <strong>Digital Performances</strong><br />
              Email: <a href="mailto:info@digitalperformances.it" className="text-white underline">info@digitalperformances.it</a><br />
              Email assistenza: <a href="mailto:assistenza@digitalperformances.it" className="text-white underline">assistenza@digitalperformances.it</a><br />
              WhatsApp: <a href="https://wa.me/393793460226" target="_blank" rel="noopener noreferrer" className="text-white underline">+39 379 346 0226</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};